<template>
    <div class="ai-prompt">
    <vue-dropzone
        ref="dropzone"
        id="invoice-dropzone"
        v-bind:options="dropzoneOptions"
        v-on:vdropzone-sending="sendingEvent"
        v-on:vdropzone-success="fileSuccess"
        useCustomSlot
    >


        <div class="columns is-vcentered">
            <div class="column">
                <div class="control has-icons-right">

                        <slot></slot>
                        <div>
                            <textarea
                                id="invoiceDropZone"
                                :disabled="promptIsDisabled"
                                class="textarea has-fixed-size"
                                placeholder="Sende eine Nachricht an ChatGPT"
                                v-model="promptText"
                                @keyup.enter="sendPrompt"
                            />
                            <div class="send-button">
                                <button
                                    :class="{'is-loading button': isSending}"
                                    class="btn-single-toggle has-border"
                                    :disabled="promptIsDisabled"
                                    v-on:click.prevent="sendPrompt"
                                ><i class="material-icons is-pointer" v-if="!isSending">send</i></button>
                            </div>
                        </div>






                </div>

            </div>
        </div>

    </vue-dropzone>
    </div>
</template>
<script>


import store from "@components/AiChat/store";
import vue2Dropzone from 'vue2-dropzone';
import {authHeader} from "@utilities/functions";
import {notifySuccess} from "@components/Notification";

export default {
    store: store,

    data () {
        return {
            dropzoneOptions: {
                url: '/api/documents/upload',
                clickable: false,
                //acceptedFiles: '.xlsx',
                maxFilesize: 20,
                uploadMultiple: false,
                maxFiles: 5,
                headers: authHeader(),
                previewTemplate: this.template(),
                createImageThumbnails: false,
                paramName: "user_file_upload",
                autoProcessQueue: false,
                accept: (file, done) =>  {
                    this.documentContent = true;
                    done();
                },
            },
        }
    },

    computed: {
        promptIsDisabled () {
            return this.$store.state.aiStore.promptIsDisabled;
        },
        isSending: {
            get () {
                return this.$store.state.aiStore.isSending;
            },
            set (value) {
                this.$store.state.aiStore.isSending = value;
            }
        },

        promptText: {
            get () {
                return this.$store.state.aiStore.promptText;
            },
            set (value) {
                this.$store.state.aiStore.promptText = value;
            }
        }
    },

    methods: {
        template: function () {
            return `<div class="dz-preview dz-file-preview" style="margin-top:0">
                        <div class="dz-details">
                            <span data-dz-name></span>
                            <div class="dz-error-message">
                                <span data-dz-errormessage></span>
                            </div>
                        </div>
                        <div class="dz-progress">
                            <span class="dz-upload" data-dz-uploadprogress></span>
                        </div>

                        <div class="dz-remove">
                            <i class="material-icons" data-dz-remove>delete</i>
                        </div>
                    </div>`;
        },

        sendPrompt () {
            this.$store.dispatch('sendPrompt')
        },
        sendingEvent: function (file, xhr, formData) {
            //formData = this.getFormData(formData, this.getDocumentName);
        },

        fileSuccess: function (file, response) {

        },
    },

    mounted () {
    },

    components: {
        vueDropzone: vue2Dropzone

    }
}

</script>

